import { Space } from 'antd'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { useEJNotificationsContext } from '../../EJNotificationsContext'
import RecipientsTags from 'components/CIMSTags/common/RecipientsTags'
import { HelpMessage } from 'utils/constants'
import NotConfigured from './components/NotConfigured'
import CIMSSection from 'components/CIMSSection'

const ViewEJNotifications: React.VFC = () => {
  const { event } = useCIMSNotificationsPanelContext()

  const { recipients } = useEJNotificationsContext()
  const { every } = recipients(event)
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <CIMSSection
        help={HelpMessage.Notifications.Every(event, 'Issue')}
        title={`Every ${event.name} Event`}
      >
        <RecipientsTags
          noRecipientsContent={<NotConfigured type="Every" />}
          recipients={every}
        />
      </CIMSSection>
    </Space>
  )
}

export default ViewEJNotifications
